import { Component, HostListener, Input } from '@angular/core';
import { ErrorDownload, NotificationService } from '../../../core/notifications.service';

@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.html',
  styleUrls: ['./error-popup.scss']
})
export class ErrorPopup {
  defaultTitle: string = $localize`:popup.error.title:שגיאה`;
  @Input() title: string | null = null;
  @Input() message: string | null = null;
  @Input() download: ErrorDownload | null = null;

  get displayTitle(): string {
    return this.title || this.defaultTitle;
  }

  constructor(private notificationService: NotificationService) {}

  downloadReport(): void {
    if (!this.download) return;
    const blob = new Blob([this.download.content], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = this.download.fileName;
    link.click();
    URL.revokeObjectURL(url);
  }

  @HostListener('document:keydown', ['$event'])
  onDocumentKeydown(event: KeyboardEvent): void {
    if (!this.message) return;
    if (event.key !== 'Enter' && event.key !== 'Escape') return;
    event.preventDefault();
    this.onConfirmRemove();
  }

  onConfirmRemove() {
    this.notificationService.hideError();
    queueMicrotask(() => this.focusFirstOtpCellIfPresent());
  }

  private focusFirstOtpCellIfPresent(): void {
    document.querySelector<HTMLElement>('.otp-input .otp-cell')?.focus();
  }
}
